import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { getStationsCounter } from '@/api/bairun/financialCenter';
import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo';
export var stations = {
  namespaced: true,
  state: {
    asyncStations: [],
    asyncStationMap: {},
    allStations: [],
    allStationMap: {}
  },
  mutations: {
    // 设置动态站点数据
    setAsyncStations: function setAsyncStations(state, asyncStations) {
      state.asyncStations = asyncStations;
    },
    // 设置动态站点数据
    setAsyncStationMap: function setAsyncStationMap(state, asyncStationMap) {
      state.asyncStationMap = asyncStationMap;
    },
    setAllStations: function setAllStations(state, allStations) {
      state.allStations = allStations;
    },
    setAllStationMap: function setAllStationMap(state, allStationMap) {
      state.allStationMap = allStationMap;
    }
  },
  actions: {
    // 从后台获取动态站点数据
    SetAsyncStations: function SetAsyncStations(_ref, groupNo) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var commit, rootGetters, userInfo, asyncStationsRes, asyncStations, asyncStationMap, allStationRes, allStations, allStationMap;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref.commit, rootGetters = _ref.rootGetters;
                userInfo = rootGetters['user/userInfo'];
                _context.next = 4;
                return getStationsCounter({
                  group: groupNo
                });

              case 4:
                asyncStationsRes = _context.sent;
                console.log('asyncStationsRes', asyncStationsRes);

                if (asyncStationsRes.code == 0) {
                  asyncStations = asyncStationsRes.data;
                  asyncStationMap = {
                    '': {}
                  };
                  asyncStations && asyncStations.forEach(function (item) {
                    asyncStationMap[String(item.ID)] = item;
                  });
                  console.log('asyncStationMap', asyncStationMap);
                  commit('setAsyncStationMap', asyncStationMap);

                  if (userInfo.sellerId > 0) {
                    asyncStations = asyncStations.filter(function (item) {
                      return item.ID == userInfo.sellerId;
                    });
                  }

                  console.log('asyncStations', asyncStations);
                  commit('setAsyncStations', asyncStations);
                }

                _context.next = 9;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 9:
                allStationRes = _context.sent;

                if (allStationRes.code == 0) {
                  allStations = allStationRes.data.list || [];
                  allStationMap = {
                    '': {}
                  };
                  allStations.forEach(function (item) {
                    allStationMap[String(item.ID)] = item;
                  });
                  console.log('allStationMap', allStationMap);
                  commit('setAllStationMap', allStationMap);

                  if (userInfo.sellerId > 0) {
                    allStations = allStations.filter(function (item) {
                      return item.ID == userInfo.sellerId;
                    });
                  }

                  console.log('allStations', allStations);
                  commit('setAllStations', allStations);
                }

                return _context.abrupt("return", true);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  getters: {
    // 获取动态站点数据
    asyncStations: function asyncStations(state) {
      return state.asyncStations;
    },
    // 获取动态站点数据
    asyncStationMap: function asyncStationMap(state) {
      return state.asyncStationMap;
    },
    allStations: function allStations(state) {
      return state.allStations;
    },
    allStationMap: function allStationMap(state) {
      return state.allStationMap;
    }
  }
};